import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuth } from './helpers';

const PrivateRoute = ({ children, roles }) => {
    const location = useLocation();

    if (isAuth() && roles) {
        const loggedUserRole = isAuth().role;

        if (roles.includes(loggedUserRole)) {
            return children;
        }

        else {
            <Navigate to={"/forbidden"} state={{ from: location }} replace={true} />
        }

    };
};

export default PrivateRoute;
